function isImageWithoutUrl(item) {
    var _a;
    return (!!item && ((_a = item.overlays) === null || _a === void 0 ? void 0 : _a.every((overlay) => overlay.printUrl !== undefined))) || false;
}
function isImageWithPrintUrl(item) {
    return !!item && item.printUrl !== undefined;
}
export function isImageItem(item) {
    return (!!item && (isImageWithPrintUrl(item) || item.previewUrl !== undefined)) || isImageWithoutUrl(item);
}
export function isTextAreaItem(item) {
    return !!item && item.content !== undefined;
}
export function isLineItem(item) {
    return !!item && item.type === 'line';
}
function isRectangleItem(item) {
    return !!item && item.type === 'rectangle';
}
function isEllipseItem(item) {
    return !!item && item.type === 'ellipse';
}
function isCurveItem(item) {
    return !!item && item.type === 'curve';
}
export function isShapeItem(item) {
    return isLineItem(item) || isEllipseItem(item) || isRectangleItem(item) || isCurveItem(item);
}
function isItemReference(item) {
    return !!item && item.data !== undefined;
}
function isItem(item) {
    if (!item) {
        return false;
    }
    return isImageItem(item) || isTextAreaItem(item) || isShapeItem(item) || isItemReference(item);
}
function isPanel(panel) {
    return !!panel && panel.height !== undefined && panel.width !== undefined;
}
export function isSubpanel(item) {
    return !!item && !isPanel(item) && !isItem(item);
}
//# sourceMappingURL=itemHelpers.js.map